import {
    CUSTOMER_TYPE_DSL,
    CUSTOMER_TYPE_MOBILE,
    CUSTOMER_TYPE_UM,
    CUSTOMER_TYPE_NON_VF,
    CUSTOMER_TYPE_VKD,
    CustomerType,
} from '@vfde-fe/sails-constants';
import { getCookieValue } from '@vfde-fe/sails_core';
import { getOverlayContent, showOverlay } from '../components/Overlay';
import { MDDKeksCookie } from '../interface';
import { USER_COOKIE_KEY } from '../constant';

/**
 * Read the user's contract type from the MDDKeks cookie
 */
export const getCustomerType = (): CustomerType | null => {
    const rawCookieValue = getCookieValue(USER_COOKIE_KEY);
    let parsedCookieValue: MDDKeksCookie;

    try {
        // Do not fail for invalid JSON value, just return `null` in that case
        parsedCookieValue = JSON.parse(decodeURIComponent(rawCookieValue)) as MDDKeksCookie;
    } catch {
        // Nothing to do
    }

    if (parsedCookieValue) {
        if (parsedCookieValue.customerType.includes(CUSTOMER_TYPE_VKD)) {
            return CUSTOMER_TYPE_VKD;
        } else if (parsedCookieValue.customerType.includes(CUSTOMER_TYPE_DSL)) {
            return CUSTOMER_TYPE_DSL;
        } else if (parsedCookieValue.customerType.includes(CUSTOMER_TYPE_MOBILE)) {
            return CUSTOMER_TYPE_MOBILE;
        } else if (parsedCookieValue.customerType.includes(CUSTOMER_TYPE_NON_VF)) {
            return CUSTOMER_TYPE_NON_VF;
        } else if (parsedCookieValue.customerType.includes(CUSTOMER_TYPE_UM)) {
            return CUSTOMER_TYPE_UM;
        }
    }

    return null;
};

/**
 * Calls the `redirectUser` public function, which is provided by `gigakombi-xsell-mobile`
 * @param contractType
 */
export const doSeamlessLogin = (contractType: CustomerType) => {
    const { VF = {} } = window as any;
    const { SAILS = {} } = VF;

    VF.SAILS = SAILS;

    if (typeof VF.SAILS.xsellMobileOverlay?.redirectCustomer === 'function') {
        VF.SAILS.xsellMobileOverlay.redirectCustomer(contractType);
    } else {
        throw new Error('Cannot find redirect function');
    }
};

/**
 * triggerGigaKombiOverlay
 */
export const triggerGigaKombiOverlay = ({ contentTarget, trigger, clickEvent }) => {
    const loggedInUserType = getCustomerType();

    let seamlessLoginStarted: boolean;

    if (loggedInUserType) {
        try {
            doSeamlessLogin(loggedInUserType);
            seamlessLoginStarted = true;
        } catch {
            seamlessLoginStarted = false;
        }
    }

    if (!seamlessLoginStarted) {
        showOverlay(contentTarget.firstElementChild);
    }

    trigger.dispatchEvent(clickEvent);
};

/**
 * triggerGigaKombiOverlay
 */
export const resetOverlayGigaKombiOverlay = ({ contentTarget, trigger, clickEvent }) => {
    const content = getOverlayContent();

    if (content.firstElementChild) {
        contentTarget.appendChild(content.firstElementChild);
        trigger.dispatchEvent(clickEvent);

        const { VF = {} } = window as any;
        const { SAILS = {} } = VF;

        VF.SAILS = SAILS;
        VF.SAILS.xsellMobileOverlay?.reset();
    }
};
